import * as form from '../form';

export const identificationName = (data = {}) => ({
  Name: form.name(data.Name),
});
